/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Remove_Subject_SuccessInputs */



/**
* | output |
* | --- |
* | "Overrides removed." |
*
* @param {Rights_Tools_Remove_Subject_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_remove_subject_success = /** @type {((inputs?: Rights_Tools_Remove_Subject_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Remove_Subject_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausnahmen entfernt.")
	return /** @type {LocalizedString} */ ("Overrides removed.")
});